import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navigation from './components/Navigation';
import RouteErrorBoundary from './components/RouteErrorBoundary';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const Buses = lazy(() => import('./pages/Buses'));
const Analytics = lazy(() => import('./pages/Analytics'));
const About = lazy(() => import('./pages/About'));
const Donate = lazy(() => import('./pages/Donate'));

const App = () => (
  <Router>
    <div className="app-shell">
      <Navigation />
      <main className="app-main">
        <Suspense fallback={<div className="page-shell"><div className="instrument-loading">Opening Magic Bus…</div></div>}>
        <Routes>
          <Route path="/" element={<RouteErrorBoundary><Dashboard /></RouteErrorBoundary>} />
          <Route path="/stops" element={<RouteErrorBoundary><Dashboard /></RouteErrorBoundary>} />
          <Route path="/buses" element={<RouteErrorBoundary><Buses /></RouteErrorBoundary>} />
          <Route path="/analytics" element={<RouteErrorBoundary><Analytics /></RouteErrorBoundary>} />
          <Route path="/about" element={<RouteErrorBoundary><About /></RouteErrorBoundary>} />
          <Route path="/donate" element={<RouteErrorBoundary><Donate /></RouteErrorBoundary>} />
        </Routes>
        </Suspense>
      </main>
      <footer className="app-footer">
        <span>Magic Bus · B61</span>
        <span>Built for Red Hook riders</span>
        <span>Data from MTA Bus Time and NYC DOT</span>
      </footer>
    </div>
  </Router>
);

export default App;
